import { DatePipe } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm, NgModel } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Collapse } from 'bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { AccountService } from 'src/app/core/services/account.service';
import { MemoryStorageService } from 'src/app/core/services/memory-storage.service';
import { environment } from 'src/environments/environment';
import swal from 'sweetalert2';
import { GeolocationService } from '../../../core/services/geolocation.service';
import { SessionTimerService } from '../../../core/services/session-timer.service';
import { UserService } from 'src/app/core/services/user.service';
import { lastValueFrom, Subscription, switchMap, timer } from 'rxjs';
import { BsLocaleService } from 'ngx-bootstrap/datepicker';

import { defineLocale } from 'ngx-bootstrap/chronos';
import { deLocale } from 'ngx-bootstrap/locale';
defineLocale('de', deLocale);

export interface iSignup {
    mobileNo: string;
    lastName: string;
    firstName: string;
    email: string;
    monthlyIncome?: number;
    travelType: string;
    travelDate: string;
    origin: string;
    destination: string;
    travelCost?: number;
    partnerTransactionId: string;
    travelAgentName: string;
    travelBrandName: string;
    travelAgentEmailId: string;
    travelAgentMobile: string;
    longitude: number;
    latitude: number;
    ipAddress: string;
    partnerId: string;
}

/**
 * Represents the component for signing up for assistance.
 */
@Component({
    selector: 'app-assist-sign-up',
    templateUrl: './assist-sign-up.component.html',
    styleUrls: ['./assist-sign-up.component.scss'],
})
export class AssistSignUpComponent implements OnInit {
    /**
     * Reference to the form element.
     */
    @ViewChild('form', { read: NgForm })
    public form!: NgForm;

    @ViewChild('collapseTwo')
    public collapseTwo: ElementRef;

    @ViewChild('collapseThree')
    public collapseThree: ElementRef;

    public bsConfig = {
        dateInputFormat: 'DD/MM/YYYY',
        showWeekNumbers: false
    };

    public consolidators: string = null;

    /**
     * Represents the sign up data.
    */
    public signUp: iSignup = {
        mobileNo: '',
        email: '',
        firstName: '',
        lastName: '',
        monthlyIncome: 0,
        travelDate: '',
        origin: '',
        destination: '',
        travelCost: 0,
        partnerTransactionId: '1',
        travelAgentName: '',
        travelBrandName: '',
        travelAgentEmailId: '',
        travelAgentMobile: '',
        longitude: 0,
        latitude: 0,
        ipAddress: '1.1.1.1',
        travelType: '',
        partnerId: '',
    };

    /**
     * Indicates whether to show personal details or not.
     */
    public showPersonalDetails: boolean = false;

    /**
     * Indicates whether to show travel details or not.
     */
    public showTravelDetails: boolean = false;

    /**
     * The minimum date for selecting a travel date.
     */
    public minDate: string;

    /**
     * The maximum date for selecting a travel date.
     */
    public maxDate: string;

    /**
     * Represents the error message.
     */
    public error: string;

    /**
     * The IP address.
     */
    public ipAddress: string;

    /**
     * The travel agent ID.
     */
    public travelAgentId: string = '';

    public travelDateValidate = false;

    public disableTravelDetail = true;

    public disableIncomeDetail = true;

    public disableAll = false;

    //validation travel cost here
    public errorMsg: string;

    public isError: boolean;

    /**
     * Initializes the component.
     */
    public mobileRegexPattern = environment.mobileRegexPattern;

    //validate MonthlyIncome
    public monthlyErroMsg: string;

    public isMonthlyError: boolean = true;

    public minimumDate: Date;

    loginMobile: string = '';
    loginOtp: string = '';
    showOtpInput: boolean = false;
    resendAvailable: boolean = false;
    public timeRemaining: number = 60;
    private timerSubscription: Subscription | undefined;
    private timerKey: string = 'otpTimerLogin';

    activeTab: 'signup' | 'login' = 'signup';
    otpmessage = '';

    setActiveTab(tab: 'signup' | 'login') {
        this.activeTab = tab;

        if (tab === 'login') {
            this.loginMobile = '';
            this.loginOtp = '';
            this.showOtpInput = false;
        }
    }

    private async generateOtp() {
        if (this.loginMobile.length === 10) {
            this.spinner.show();
            try {
                var res = await lastValueFrom(this.accountService.GenerateOTP({ mobileNo: this.loginMobile }));
                if (res['data']) {
                    //swal.fire('OTP sent successfully to ' + this.loginMobile);
                    this.otpmessage = 'OTP sent successfully to ' + this.loginMobile;
                    this.showOtpInput = true;
                    MemoryStorageService.setItem(this.timerKey, (new Date().getTime() + (60 * 1000)).toString());
                    this.loadTimer();
                    this.startTimer();
                    this.spinner.hide();
                }
                else {
                    this.otpmessage = res['error']['response_msg'];
                }
            } catch (error: any) {
                if (error.status === 0) {
                    swal.fire("No internet connection. Please check your network and try again.");
                    return;
                }
                if (error?.status === 401 && error?.error?.message === 'Token has expired') {
                    // Redirect to /abc if token expired
                    this.router.navigateByUrl('/assist-journey/session-expired');
                }
            } finally {
                this.spinner.hide();
            }

        } else {
            swal.fire('Please enter a valid 10-digit mobile number');
        }
    }

    async login() {
        if (this.loginOtp.length > 0) {
            this.spinner.show();
            try {
                var res = await lastValueFrom(this.accountService.Login({ mobileNo: this.loginMobile, otp: this.loginOtp }));
                if (res['data']) {
                    MemoryStorageService.setItem('customerToken', res['data']['token']);
                    this.spinner.hide();
                    this.router.navigateByUrl('/assist-journey/lender-selection');
                }

                else {
                    this.otpmessage = res['error']['response_msg'];
                }
            } catch (error: any) {
                if (error.status === 0) {
                    swal.fire("No internet connection. Please check your network and try again.");
                    return;
                }
                if (error?.status === 401 && error?.error?.message === 'Token has expired') {
                    // Redirect to /abc if token expired
                    this.router.navigateByUrl('/assist-journey/session-expired');
                }
            } finally {
                this.spinner.hide();
            }
        }
    }

    constructor(
        private accountService: AccountService,
        private geolocationService: GeolocationService,
        private route: ActivatedRoute,
        private router: Router,
        private spinner: NgxSpinnerService,
        private sessionTimerService: SessionTimerService,
        private datePipe: DatePipe,
        private userService: UserService,
        private localeService: BsLocaleService
    ) { }

    public async ngOnInit(): Promise<void> {
        this.spinner.hide();
        //Clear MemoryStorageService
        MemoryStorageService.clear();

        const date = new Date();
        const dateNumber = date.getTime();
        this.signUp.partnerTransactionId = dateNumber.toString();

        this.geolocationService.getCurrentPosition().then((position) => {
            this.signUp.latitude = position.latitude;
            this.signUp.longitude = position.longitude;
        }).catch((error) => {
            this.error = error.message;
        });


        if (this.route.snapshot.queryParamMap.get('hideheader') || this.route.snapshot.queryParamMap.get('hidefooter')) {

        }
        //utm_source means agent id which can be found in Airtable TA-India 
        if (this.route.snapshot.queryParamMap.get('utm_source') != null) {
            this.travelAgentId = this.route.snapshot.queryParamMap
                .get('utm_source')
                ?.toString()
                .toUpperCase();
            this.signUp.partnerId = this.travelAgentId;
            //set partner logo based on Partner
            //this.partnerLogo();

        }
        else {
            MemoryStorageService.removeItem('partnerLogourl');
        }

        if (this.route.snapshot.queryParamMap.get('q')) {
            this.signUp.partnerTransactionId = await this.userService.decryptData(this.route.snapshot.queryParamMap.get('q')!, '');
            console.log('Decrypted partnerTransactionId:', this.signUp.partnerTransactionId);
        }

        if (this.route.snapshot.queryParamMap.get('mobile') && this.route.snapshot.queryParamMap.get('email') && this.route.snapshot.queryParamMap.get('mobile') != null && this.route.snapshot.queryParamMap.get('email') != null) {
            const encodedMobile = this.route.snapshot.queryParamMap.get('mobile');
            const encodedEmail = this.route.snapshot.queryParamMap.get('email');

            if (encodedMobile) {
                this.signUp.mobileNo = await this.userService.decryptData(decodeURIComponent(encodedMobile), '');
                MemoryStorageService.setItem('userSource', 'LANDING_PAGE_WIDGET');
            }

            if (encodedEmail) {
                this.signUp.email = await this.userService.decryptData(decodeURIComponent(encodedEmail), '');
            }
        }

        this.spinner.show();
        await this.getAgentDetails();
        this.spinner.hide();

        //for logos 
        if (this.consolidators) {
            this.accountService.setPartnerLogo("https://itraveleoblogdiag865.blob.core.windows.net/websiteimages/assets/logos/" + this.consolidators + ".png");
        }

        // For Hiding Timer
        this.sessionTimerService.SetShowTimer(false);
        MemoryStorageService.removeItem('timerEndTime');

    }

    public startTimer(): void {
        const now = new Date().getTime();
        const savedExpiryTime = MemoryStorageService.getItem(this.timerKey);
        if (savedExpiryTime) {
            const expiryTime = parseInt(savedExpiryTime, 10);
            this.timeRemaining = Math.max(Math.floor((expiryTime - now) / 1000), 0);
            this.resendAvailable = this.timeRemaining === 0;
        }
        this.timerSubscription = timer(0, 1000).pipe(switchMap(() => {
            if (this.timeRemaining > 0) {
                this.timeRemaining--;
                this.saveTimer();
                return [this.timeRemaining];
            } else {
                this.resendAvailable = true;
                MemoryStorageService.removeItem(this.timerKey);
                if (this.timerSubscription) {
                    this.timerSubscription.unsubscribe();
                }
                return [];
            }
        })).subscribe();
    }

    public saveTimer(): void {
        const expiryTime = new Date().getTime() + (this.timeRemaining * 1000);
        MemoryStorageService.setItem(this.timerKey, expiryTime.toString());
    }

    public loadTimer(): void {
        const savedExpiryTime = MemoryStorageService.getItem(this.timerKey);
        if (savedExpiryTime) {
            const now = new Date().getTime();
            const expiryTime = parseInt(savedExpiryTime, 10);
            this.timeRemaining = Math.max(Math.floor((expiryTime - now) / 1000), 0);
            this.resendAvailable = this.timeRemaining === 0;
        }
    }

    public async resendOtp() {
        this.timeRemaining = 60;
        this.saveTimer();
        this.resendAvailable = false;
        this.startTimer();
        let partnerAuthTokenRequest: any = {
            partnerId: this.travelAgentId,
            apiKey: 'c3a3e4b9-4564-45c0-9698-d644a19cb9bA',
        };
        await lastValueFrom(this.accountService.generatePartnerToken(partnerAuthTokenRequest)).then(
            async (token) => {
                this.accountService.resendOTPMobile(this.loginMobile, token['data']).subscribe(
                    (res) => {
                        if (res['data'] != null && res['data']['response_summary'] != null) {
                            swal.fire(res['data']['response_summary']);
                        }
                        else if (res['error'] != null && res['error']['response_summary'] == "Max 5 OTP can be send on 15min interval") {
                            MemoryStorageService.removeItem(this.timerKey);
                            if (this.timerSubscription) {
                                this.timerSubscription.unsubscribe();
                            }
                            this.timeRemaining = 60 * 15;
                            this.saveTimer();
                            this.resendAvailable = false;
                            this.startTimer();
                            swal.fire(res['error']['response_summary']);
                        }
                        else {
                            swal.fire(res['error']['response_summary']);
                        }
                    },
                    (error) => {
                        this.spinner.hide();
                        //swal.fire('Unhandled error occured, please try again later.');
                    }
                );
            },
            (error) => {
                this.spinner.hide();
                swal.fire('Please check URL and try again');
            }
        );

    }

    /**
     * Executes after the view has been initialized.
     */
    public ngAfterViewInit(): void {
        const today = new Date();
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        const nextYear = new Date();
        nextYear.setFullYear(today.getFullYear() + 1);

        this.minimumDate = tomorrow;

        this.minDate = this.formatDate(tomorrow);
        this.maxDate = this.formatDate(nextYear);

    }

    /**
     * Formats the given date to a string in the format 'YYYY-MM-DD'.
     * @param date - The date to format.
     * @returns The formatted date string.
     */
    public formatDate(date: Date): string {
        const day = ('0' + date.getDate()).slice(-2);
        const month = ('0' + (date.getMonth() + 1)).slice(-2);
        const year = date.getFullYear();
        return `${year}-${month}-${day}`;
    }

    /**
     * Determines whether to show validation for the given form control.
     * @param formControl - The form control to check.
     * @returns True if validation should be shown, false otherwise.
     */
    public shouldShowValidation(formControl: NgModel) {
        return (
            formControl &&
            formControl.invalid &&
            formControl.touched &&
            (formControl.dirty ||
                this.form?.submitted ||
                formControl.errors.required ||
                formControl.errors.pattern ||
                formControl.errors.min ||
                formControl.errors.max)
        );
    }

    //call partnerlogohere
    public validateTravelDate() {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        if (this.signUp.travelDate == '' || (new Date(this.signUp.travelDate) < new Date(this.formatDate(tomorrow)))) {
            this.travelDateValidate = true;
            return;
        }
        this.travelDateValidate = false;
    }

    public partnerLogo() {
        const body = { RegID: this.travelAgentId };
        this.accountService.getLogoUrl(body).subscribe(
            (res: any) => {
                if (res.status === 'success' && res.response.Error != 'true') {
                    this.accountService.setPartnerLogo(res.response.Logo)
                }
            });
    }

    /**
     * Submits the sign up form.
     */
    public async submit() {
        this.spinner.show();
        let partnerAuthTokenRequest: any = {
            partnerId: this.travelAgentId,
            apiKey: 'c3a3e4b9-4564-45c0-9698-d644a19cb9bA',
        };
        await this.getAgentDetails();
        // this.signUp.travelAgentName = 'sejuti2010 Alyf agent';
        // this.signUp.travelBrandName = 'sejuti2010 Alyf agent';
        // this.signUp.travelAgentEmailId = 'sejuti2010+alyfagent@gmail.com';
        // this.signUp.travelAgentMobile = '9877656544';

        await lastValueFrom(this.accountService.generatePartnerToken(partnerAuthTokenRequest)).then(
            async (token) => {
                await lastValueFrom(this.accountService.signup(this.signUp, token['data'])).then(
                    (res) => {
                        if (res['data'] != null) {
                            console.log(token['data']);
                            MemoryStorageService.setItem('partnerToken', token['data']);
                            MemoryStorageService.setItem('mobile', this.signUp.mobileNo);
                            MemoryStorageService.setItem('email', this.signUp.email);
                            MemoryStorageService.setItem('firstname', this.signUp.firstName)
                            MemoryStorageService.setItem('lastname', this.signUp.lastName)
                            MemoryStorageService.setItem('TravelCost', "" + this.signUp.travelCost);
                            MemoryStorageService.setItem('accessToken', token['data']);
                            //redirect to the submit otp page
                            this.spinner.hide();

                            //Reset OTP Timer 
                            MemoryStorageService.setItem('otpTimer', (new Date().getTime() + (60 * 1000)).toString());

                            this.router.navigateByUrl('/assist-journey/submit-otp');
                        }
                        else if (res['error'] != null) {
                            this.spinner.hide();
                            swal.fire(res['error']['response_summary']);
                        }
                        else {
                            this.spinner.hide();
                            swal.fire('There was an error! Please try again!');
                        }
                    },
                    (error) => {
                        this.spinner.hide();
                        swal.fire('There was an error! Please try again!');
                        console.log(error);
                    }
                );
            },
            (error) => {
                this.spinner.hide();
                swal.fire('Please check URL and try again');
            }
        );
    }

    //clear monthlyincome
    public clearInitialValue(event: any): void {
        const fieldName = event.target.name;
        if (fieldName === 'monthlyIncome' && this.signUp.monthlyIncome === 0) {
            this.signUp.monthlyIncome = null;
        } else if (fieldName === 'travelCost' && this.signUp.travelCost === 0) {
            this.signUp.travelCost = null;
        }
    }

    //GetAgentDetails
    public async getAgentDetails(): Promise<void> {
        if (this.travelAgentId != '') {
            try {
                const agentDetails: any = await this.accountService.getAgentDetails(this.travelAgentId.toUpperCase()).toPromise();
                console.log(agentDetails);
                if (agentDetails != null) {
                    this.signUp.travelAgentName = agentDetails.ownerDirectorName;
                    this.signUp.travelBrandName = agentDetails.brandName;
                    this.signUp.travelAgentEmailId = agentDetails.email;
                    this.signUp.travelAgentMobile = agentDetails.mobile.toString();
                    this.consolidators = agentDetails.consolidator || null;
                    if (agentDetails != null && agentDetails.consolidator != null && agentDetails.consolidator.length > 0) {
                        MemoryStorageService.setItem("consolidatorId", agentDetails.consolidator[0] || null);
                    }
                    MemoryStorageService.setItem("userSource", MemoryStorageService.getItem('userSource') === 'LANDING_PAGE_WIDGET' ? 'LANDING_PAGE_WIDGET' : 'LANDING_PAGE');
                } else {
                    swal.fire('Please check Agent ID and try again!');
                }
            } catch (error) {
                console.error('Error fetching agent details:', error);
            }
        }
    }

    public allowOnly(event: KeyboardEvent, type: string): void {
        const input = event.target as HTMLInputElement;
        let allowedPattern;

        if (type === 'numbers') {
            allowedPattern = /[^0-9]/g; // Match anything that's not a number
        } else if (type === 'alphabets') {
            allowedPattern = /[^a-zA-Z\s']/g; // Match anything that's not a letter
        }

        // Use input event to handle changes
        input.addEventListener('input', (e: Event) => {
            const currentValue = input.value;
            input.value = currentValue.replace(allowedPattern, '');
        });
    }

    public toUpperCase(event: any) {
        event.target.value = event.target.value.toUpperCase();
    }

    public validateTravelCost() {
        const minCost = 10000;
        const maxCost = 1000000;
        const currentCost = this.signUp.travelCost;

        if (this.signUp.travelCost == null) {
            this.isError = true;
            this.errorMsg = 'Trip cost is required.';
            return;
        }

        if (currentCost < minCost) {
            this.errorMsg = `The minimum trip cost is ₹${minCost}.`;
            this.isError = true;
        } else if (currentCost > maxCost) {
            this.errorMsg = `The maximum trip cost is ₹${maxCost}.`;
            this.isError = true;
        }
        else {
            this.isError = false;
        }

    }

    public validateMonthlyincome(event) {
        const fieldName = event.target.name;

        if (fieldName === 'monthlyIncome' && this.signUp.monthlyIncome === 0) {
            this.signUp.monthlyIncome = null;
        }

        const minIncome = 15000;
        const maxIncome = 10000000;
        const currentIncome = this.signUp.monthlyIncome;

        if (this.signUp.monthlyIncome == null) {
            this.isMonthlyError = true;
            this.monthlyErroMsg = 'Monthly Income is required.';
            return;
        }

        if (currentIncome < minIncome) {
            this.monthlyErroMsg = `The minimum Income is ₹${minIncome}.`;
            this.isMonthlyError = true;
        } else if (currentIncome > maxIncome) {
            this.monthlyErroMsg = `The maximum Income is ₹${maxIncome}.`;
            this.isMonthlyError = true;
        }
        else {
            this.isMonthlyError = false;
        }
    }

    public onInputChange(value: string) {
        this.signUp.mobileNo = value.replace(/\D/g, '');
    }

    public onInputDateChange(event: KeyboardEvent) {
        const key = event.key.toLowerCase();
        if (key !== 'backspace' && key !== 'tab') {
            event.preventDefault();
        }
    }

    public showTravelDetailsFun(val) {
        this.showTravelDetails = val;
        setTimeout(() => {
            if (this.collapseThree) {
                const collapse = new Collapse(this.collapseThree.nativeElement, { toggle: false });
                collapse.show();
            }
        });
    }

    public async GetSignInData(val) {
        try {
            this.showPersonalDetails = val;
            setTimeout(() => {
                if (this.collapseTwo) {
                    const collapse = new Collapse(this.collapseTwo.nativeElement, { toggle: false });
                    collapse.show();
                }
            });
        }
        catch (err) {
            console.log(err);
        }
    }

    public handleTravelDateChange(value: Date) {
        const year = value.getFullYear();
        const month = (value.getMonth() + 1).toString().padStart(2, '0');
        const date = value.getDate().toString().padStart(2, '0');

        this.signUp.travelDate = `${year}-${month}-${date}`;
    }


    private restoreBase64(value: string): string {
        // Replace lowercase 'a-z' with correct Base64 equivalents, if necessary
        return value.replace(/[^a-zA-Z0-9+/=]/g, '');
    }


    private decodeBase64(value: string): string {
        try {
            return atob(value);
        } catch (error) {
            console.error('Invalid Base64 string:', value);
            return '';
        }
    }
}
